<template>
    <div class="menu-bar">
        <ul>
            <li class="menu_home">
                <router-link to="/landing">
                    <img src="../assets/home_black_24dp.svg" alt="">
                    <p>ホーム</p>
                </router-link>
            </li>
            <li>
                <router-link to="/notifications">
                    <img v-if="alert" src="../assets/notifications_new_info.svg" alt="">
                    <img v-else src="../assets/notifications_none-24px.svg" alt="">
                    <p>お知らせ</p>
                </router-link>
            </li>
            <li>
                <router-link to="/search">
                    <img src="../assets/search_black_24dp.svg" alt="" @click="search()">
                    <p>探す</p>
                </router-link>
            </li>
            <li>
                <router-link to="/sell">
                    <img src="../assets/photo_camera-24px.svg" alt="">
                    <p>出品</p>
                </router-link>
            </li>
            <li>
                <router-link to="/profile">
                    <img src="../assets/account_circle_black_24dp.svg" alt="">
                    <p>アカウント</p>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import db from '../plugins/firestore'
import firebase from '../plugins/firebase'
export default {
    data(){
        return {
            userID: '',
            notifications:[],
            alert: false //未読のメッセージがあるかどうかのフラグ
        }
    },
    created() {
        firebase.auth().onAuthStateChanged(user => {
            if(!user){
                this.$router.push({path: "/"})
            }else{
                this.userID = user.uid
                var userID = user.uid
                db.collection("users").doc(userID).collection("information").orderBy("timestamp", "desc").get().then(snap => {
                    const array = [];
                    snap.forEach(doc => {
                        const itemData = doc.data(); //itemDataオブジェクト（商品情報）を設定
                        itemData.itemID = doc.id; //itemDataにドキュメントIDを付与(商品ID)
                        array.push(itemData); //itemDataを配列arrayに入れる
                    });
                    this.notifications = array
                    for(var i = 0; i < this.notifications.length; i++) {
                        if(!this.notifications[i].isRead){ //もし、未読なら
                            this.alert = true              //alertをtrueに
                        }
                    }
                });
            }
        })
    },
    methods: {
        //検索するを押したら、vuexで管理されている検索結果を消す処理
        search() {
            this.$store.dispatch('searchResult', '')
            this.$router.push({path: '/search'})
        }
    }
}
</script>

<style scoped>
    .menu-bar {
        padding: 1%;
        width: 100%;
        background-color: white;
        /* position: sticky; */
        /* padding */
        margin-top:auto;
        position: fixed !important;
        bottom: 0;
        margin-top: 30px;

    }
    .menu-bar ul{
        display: flex;
        list-style: none;
    }

    .menu-bar li {
        width: 20%;
        text-align: center;
    }

    .menu-bar li:active{
                background-color: rgba(0, 0, 0, 0.5)!important;
        border-radius: 5%;
    }

    .menu-bar p {
        color: black;
    }

    

    /* .menu_home{
        background-color:red;
    } */

    /* .menu_home:active{
        background-color: rgba(0, 0, 0, 0.5)!important;
        border-radius: 5%;

    } */

@media all and (max-width:670px){
    .menu-bar p {
        font-size: 12px;
    }
}
</style>